import user from './userUseCase'
import auth from './authUseCase'
import {userRepo, authRepo} from "../repositories";
import {userService, authService} from "../services";

export const userUseCase = user(
    userRepo(
        userService()
    )
)

export const authUseCase = auth(
    authRepo(
        authService()
    )
)